"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _openVideo = require("@/api/openVideo/openVideo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialog: false,
      fromData: {
        createBy: "",
        createTime: "",
        id: "",
        isDelete: "",
        name: "",
        provinceId: this.$store.getters.provinceId,
        remark: "",
        sort: 0,
        updateTime: ""
      },
      rules: {
        name: [{
          required: true,
          message: '此项不能为空',
          trigger: 'blur'
        }]
      },
      tit: '新增类型',
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "类型名称",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "100",
        timeFormat: "dateYMD"
      }],
      minWidth: 200,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {},
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      checkBoxs: []
    };
  },
  methods: {
    submit: function submit(v) {
      var _this = this;
      console.log("v", v);
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _openVideo.videoTypeUpload)(_this.fromData).then(function (res) {
            if (res.msg == '操作成功') {
              _this.$message.success(res.msg);
              _this.close();
              _this.getList();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close: function close() {
      this.dialog = false;
      this.fromData.name = '';
      this.fromData.id = '';
    },
    // 新增
    add: function add() {
      this.dialog = true;
      this.tit = '新增类型';
    },
    // 编辑
    edit: function edit(e) {
      console.log('e', e);
      this.dialog = true;
      this.tit = '编辑类型';
      this.fromData.name = e.name;
      this.fromData.id = e.id;
    },
    // 获取视频分类管理列表
    getList: function getList() {
      var _this2 = this;
      (0, _openVideo.videoTypeList)({
        name: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        var data = res.data;
        _this2.listData = data.list;
        _this2.totalData = data.total;
        // this.$store.commit('settings/getwVideoClassification', res.data)
        // console.log('this.listData',this.listData)
      });
    },
    // 模糊搜索新闻分类
    search: function search(val) {
      this.queryValue = val.queryValue;
      this.getList();
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this3 = this;
      console.log('row', row);
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _openVideo.videoTypeDelete)({
          idList: id
        }).then(function () {
          _this3.getList();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消删除。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this4 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getList();
    }
  },
  created: function created() {
    this.getList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};